import React, { useState, memo, useEffect } from 'react';
import {    getApiUrl, 
            getRessouresUrl, 
            ellipsify, 
            cleanDisplayFilename, 
            isValidHttpUrl, 
            humanReadableFileSize } from './../../../utils/config';
import { getToken } from './../../../session-utils/UserSession';
import { Container, Col, Row, Modal, Button, Form, CloseButton } from 'react-bootstrap';
import { faPlus, faPencilAlt, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './../../../assets/css/style.css';
import 'react-awesome-button/dist/styles.css';


async function actionNews(action, credentials) {
    if (action === "add" || action === "edit") {
        return fetch(getApiUrl() + "news/" + action, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            body: credentials
        })
        .then(data => data.json())
        .then(data => { return data.news })
        .catch(error => console.log(error))
    } else if (action === "remove") {
        return fetch(getApiUrl() + "news/" + action, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            cache: 'default',
            body: JSON.stringify({ _id: credentials })
        })
        .then(data => data.json())
        .catch(error => console.log(error))
    }
}

async function createTempFileFromURL(mediaURL, filename) {
    let response = await fetch(mediaURL);
    let data = await response.blob();
    let metadata = {
        type: 'application/pdf'
    };
    
    return new File([data], filename, metadata);
}

function NewsModal(props) {
    const [modalShow, setModalShow] = useState(false);
    const [formFileUploadRef, setFormFileUploadRef] = useState(React.createRef(null));
    const [formImgUploadRef, setFormImgeUploadRef] = useState(React.createRef(null));

    let [title, setTitle] = useState("");
    let [description, setDescription] = useState("");
    let [newsDocs, setNewsDocs] = useState([]);
    let [deleteNewsDocs, setDeleteNewsDocs] = useState([]);
    let [newsImages, setNewsImages] = useState([]);
    let [deleteNewsImages, setDeleteNewsImages] = useState([]);
    let [links, setLinks] = useState([]);

    let [mediaLink, setMediaLink] = useState("");
    let [displayMediaLink, setDisplayMediaLink] = useState("");

    let news = props.news;
    if (props.news === undefined || props.news === null) {
        // In Addititon Mode
        news = {
            title: "",
            description: "",
            publicationDate: "",
            newsDocs: [],
            newsImages: [],
            links: []
        }
    } 

    let modal = {
        header: undefined,
        title: undefined,
        description: undefined,
        button: undefined,
        icon: undefined,
        buttonVariant: undefined,
        size: undefined
    };

    const handleAddLink = e => {
        e.preventDefault();

        let linkItem = {
            link: '',
            display: ''
        }

        if (mediaLink !== undefined) {
            if (mediaLink.trim().length !== 0) {
                linkItem.link = mediaLink.trim();
                if (displayMediaLink !== undefined) {
                    if (displayMediaLink.trim().length !== 0) {
                        linkItem.display = displayMediaLink.trim();
                    }
                }
                // Add link item to links clone list 
                setLinks([...links, linkItem]);
            }
        }

        setMediaLink("");
        setDisplayMediaLink("");
    }

    const handleRemoveLink = (e, index) => {
        e.preventDefault();

        const temp_links = [...links];
        temp_links.splice(index, 1);
        setLinks(temp_links);
    }

    const linksList = links.map((data, index) => (
        <div key={data.link+index}>
            <Row>
                <Col sm={9} style={{ padding: '0px 32px' }}>
                    <table><tbody>
                        <tr>
                            <td>
                                <span>
                                    <b>Link: </b>
                                    <a  href={data.link}
                                        title={data.link}
                                        target="_blank"
                                        rel="noreferrer">
                                            {ellipsify(data.link)}
                                    </a>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Display as: </b>
                                {(data.display !== undefined || data.display !== '')
                                    ? ellipsify(data.display)
                                    : "None"
                                }
                            </td>
                        </tr>
                    </tbody></table>
                </Col>
                <Col sm={3} style={{ padding: '0px', textAlign: 'center' }}>
                    <Button variant="outline-danger"
                            style={{ borderRadius: "15px" }}
                            onClick={e => handleRemoveLink(e, index)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </Col>
            </Row>
            {index !== (links.length - 1)
                ? <hr />
                : null
            }
        </div>
    ));

    const handleAutomaticFormDocFileInputClick = () => {
        formFileUploadRef.current.click()
    }

    const handleAutomaticFormImgFileInputClick = () => {
        formImgUploadRef.current.click()
    }

    const handleAddDocs = (e) => {
        e.preventDefault();

        const targetFiles = Array.prototype.slice.call(e.target.files);
        const docFiles = [...newsDocs];
        targetFiles.some((file) => {
            // Check if file does not already exist in files list
            if (docFiles.findIndex((f) => f.name === file.name) === -1
                && docFiles.findIndex((f) => cleanDisplayFilename(f.name) === file.name) === -1) {
                    if (file.type === "application/pdf") {
                        docFiles.push(file);
                    } else {
                        alert("Please provide a valid PDF document");
                    }
            } else {
                alert(`The document entitled ${file.name} is already included in the list`);
            }
            return null;
        })

        setNewsDocs(docFiles);
        e.target.value = '';
    }

    const handleRemoveDoc = (e, index) => {
        e.preventDefault();

        const docFiles = [...newsDocs];
        const deletedDocName = docFiles[index].name;
        docFiles.splice(index, 1);

        setNewsDocs(docFiles);

        // Check if deleted CV is already a stored file or a temporary addition
        if (deletedDocName.includes("uploads/news/"))
            setDeleteNewsDocs([...deleteNewsDocs, deletedDocName]);
        
        e.target.value = '';
    }

    const docsList = Array.from(newsDocs).map((file, index) => (
        <div key={file.name}>
            <Row>
                <Col sm={9} style={{ padding: '0px 32px' }}>
                    <table><tbody>
                        <tr>
                            <td>
                                <span>
                                    <b>File name: </b>
                                    <a  href={URL.createObjectURL(file)}
                                        title={cleanDisplayFilename(file.name)}
                                        target="_blank"
                                        rel="noreferrer">
                                            {cleanDisplayFilename(file.name)}
                                    </a>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>File size: </b>
                                {humanReadableFileSize(file.size)}
                            </td>
                        </tr>
                    </tbody></table>
                </Col>
                <Col sm={3} style={{ padding: '0px', textAlign: 'center' }}>
                    <Button variant="outline-danger"
                            style={{ borderRadius: "15px" }}
                            onClick={e => handleRemoveDoc(e, index)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </Col>
            </Row>
            {index !== (newsDocs.length - 1)
                ? <hr />
                : null
            }
        </div>
    ));

    const handleAddImgs = (e) => {
        e.preventDefault();

        const targetImgs = Array.prototype.slice.call(e.target.files);
        const imgFiles = [...newsImages];
        targetImgs.some((file) => {
            // Check if file does not already exist in files list
            if (imgFiles.findIndex((f) => f.name === file.name) === -1
                && imgFiles.findIndex((f) => cleanDisplayFilename(f.name) === file.name) === -1) {
                    if (file.type === "image/png" ||
                        file.type === "image/jpg" ||
                        file.type === "image/jpeg") {
                        imgFiles.push(file);
                    } else {
                        alert("Please provide a valid image file");
                    }
            } else {
                alert(`The image entitled ${file.name} is already included in the list`);
            }
            return null;
        })

        setNewsImages(imgFiles);
        e.target.value = '';
    }

    const handleRemoveImg = (e, index) => {
        e.preventDefault();

        const imgFiles = [...newsImages];
        const deletedImgName = imgFiles[index].name;
        imgFiles.splice(index, 1);

        setNewsImages(imgFiles);

        // Check if deleted CV is already a stored file or a temporary addition
        if (deletedImgName.includes("uploads/news/"))
            setDeleteNewsImages([...deleteNewsImages, deletedImgName]);
        
        e.target.value = '';
    }

    const imgsList = Array.from(newsImages).map((file, index) => (
        <div key={file.name}>
            <Row>
                <Col sm={9} style={{ padding: '0px 32px' }}>
                    <table><tbody>
                        <tr>
                            <td>
                                <span>
                                    <b>Image name: </b>
                                    <a  href={URL.createObjectURL(file)}
                                        title={cleanDisplayFilename(file.name)}
                                        target="_blank"
                                        rel="noreferrer">
                                            {cleanDisplayFilename(file.name)}
                                    </a>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>File size: </b>
                                {humanReadableFileSize(file.size)}
                            </td>
                        </tr>
                    </tbody></table>
                </Col>
                <Col sm={3} style={{ padding: '0px', textAlign: 'center' }}>
                    <Button variant="outline-danger"
                            style={{ borderRadius: "15px" }}
                            onClick={e => handleRemoveImg(e, index)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </Col>
            </Row>
            {index !== (newsImages.length - 1)
                ? <hr />
                : null
            }
        </div>
    ));

    const handleClose = () => {
        setModalShow(false);
        setFormFileUploadRef(React.createRef(null));
        setFormImgeUploadRef(React.createRef(null));

        setTitle("");
        setDescription("");
        setNewsImages([]);
        setDeleteNewsImages([]);
        setNewsDocs([]);
        setDeleteNewsDocs([]);
        setLinks([]);
    
        setMediaLink("");
        setDisplayMediaLink("");
    }

    const setDocFilesFromURL = async (files) => {
        if (props.action === "edit") {
            // Set Docs with Files array instead of Paths array
            if (files !== undefined && files.length !== 0) {
                // Create File items based off stored file paths
                const loadedDocs = [...files];
                var docFiles = [];
                loadedDocs.forEach(async (filepath) => { 
                    await createTempFileFromURL(getRessouresUrl()+filepath, filepath)
                    .then((file) => docFiles.push(file))
                    .catch((error) => console.log(error))
                    setNewsDocs([...docFiles])
                });
            } else {
                setNewsDocs(files)
            }
        }
    }

    const setImgFilesFromURL = async (files) => {
        if (props.action === "edit") {
            // Set Docs with Files array instead of Paths array
            if (files !== undefined && files.length !== 0) {
                // Create File items based off stored file paths
                const loadedImgs = [...files];
                var imgFiles = [];
                loadedImgs.forEach(async (filepath) => { 
                    await createTempFileFromURL(getRessouresUrl()+filepath, filepath)
                    .then((file) => imgFiles.push(file))
                    .catch((error) => console.log(error))
                    setNewsImages([...imgFiles])
                });
            } else {
                setNewsImages(files)
            }
        }
    }

    useEffect((files) => {
        setDocFilesFromURL(files? news.newsDocs : []);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect((files) => {
        setImgFilesFromURL(files? news.newsImages : []);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleShow = () => {
        // Set news attributes in State variables
        setTitle(news.title);
        setDescription(news.description);
        setLinks(news.links);
        // set Docs
        setDocFilesFromURL(news.newsDocs);
        setDeleteNewsDocs([]);
        // set Imgs
        setImgFilesFromURL(news.newsImages);
        setDeleteNewsImages([]);

        setModalShow(true);
    }

    const handleActionNews = async e => {
        e.preventDefault();

        let temp;
        let publishingTimestamp = new Date();
        
        if (props.action === "add") {
            temp = {
                title,
                description,
                publicationDate: publishingTimestamp.toString(),
                links
            }
        } else if (props.action === "edit") {
            temp = {
                _id: props.id,
                title,
                description,
                links
            }
        } 

        const news = temp;
        let thingData = new FormData();

        if (props.action === "add" || props.action === "edit") {
            thingData.append('news', JSON.stringify(news));

            // Files to upload
            if (newsDocs !== undefined) {
                Array.from(newsDocs).map((doc) => {
                    
                    // If file includes path to file storage, then ignore.
                    // (This means that the file has already been uploaded and stored.)
                    if (doc.name.includes('uploads/news/')){
                        return null;
                    }

                    thingData.append('news', doc, doc.name);
                    return null;
                });
            }

            // List of file (paths) to delete
            if (deleteNewsDocs !== undefined) {
                thingData.append('deletedocs', JSON.stringify([...deleteNewsDocs]));
            }

            // Images to upload
            if (newsImages !== undefined) {
                Array.from(newsImages).map((img) => {
                    
                    // If file includes path to file storage, then ignore.
                    // (This means that the file has already been uploaded and stored.)
                    if (img.name.includes('uploads/news/')){
                        return null;
                    }

                    thingData.append('news', img, img.name);
                    return null;
                });
            }

            // List of file (paths) to delete
            if (deleteNewsImages !== undefined) {
                thingData.append('deleteimgs', JSON.stringify([...deleteNewsImages]));
            }

        } else if (props.action === "remove") {
            thingData = props.news._id;
        }

        await actionNews(props.action, thingData);
        handleClose();
        props.loadAll();
    }

    if (props.action === "add") {
        modal.header = "Add new news article";
        modal.title = "";
        modal.description = "";
        modal.button = "Add new news article";
        modal.icon = faPlus;
        modal.buttonVariant = "primary";
        modal.size = "xl";

    } else if (props.action === "edit") {
        modal.header = "Edit news article information";
        modal.title = "";
        modal.description = "";
        modal.button = "Edit";
        modal.icon = faPencilAlt;
        modal.buttonVariant = "warning";
        modal.size = "xl";

    } else if (props.action === "remove") {
        modal.header = "Delete news article";
        modal.title = "Are you sure you want to delete this news article?";
        modal.description = "This news article will be permanently deleted, this action cannot be undone.";
        modal.button = "Delete";
        modal.icon = faTrash;
        modal.buttonVariant = "danger";
        modal.size = "md";
    }

    const btnVariant = "outline-" + modal.buttonVariant;

    return (
        <>
            <Button variant={btnVariant}
                    onClick={() => handleShow()}>
                {modal.button}&nbsp;&nbsp;
                <FontAwesomeIcon icon={modal.icon} />
            </Button>

            <Modal  show={modalShow}
                    size={modal.size}
                    onHide={handleClose}
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered >
                <form   onSubmit={handleActionNews} 
                        encType="multipart/form-data" 
                        className=" card-modal">
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {modal.header}
                        </Modal.Title>
                        <CloseButton    aria-label="Hide popup" 
                                        onClick={() => handleClose()} />
                    </Modal.Header>
                    <Modal.Body>
                        {modal.title
                            ? <h5>{modal.title}</h5>
                            : null
                        }
                        {modal.description
                            ? <p>{modal.description}</p>
                            : null
                        }
                        {(props.action === "add" || props.action === "edit")
                            ?
                            <Container className="custom-modal">
                                <div className="modal-container-xlg">
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <b>Title</b> <span className='important-text'>*</span>
                                            </Form.Label>
                                            <Form.Control   type="text"
                                                            name="title"
                                                            value={title}
                                                            onChange={e => setTitle(e.target.value)}
                                                            autoFocus required />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <b>Description</b> <span className='important-text'>*</span>
                                            </Form.Label>
                                            <Form.Control 
                                                type="text"
                                                as="textarea" 
                                                rows={7}
                                                name="description"
                                                value={description}
                                                onChange={e => setDescription(e.target.value)}
                                                required />
                                        </Form.Group>
                                    </Col>
                                </div>
                                <div className="modal-container">
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label><b>Files and Documents</b></Form.Label>
                                            <Form.Control 
                                                type="file"
                                                ref={formFileUploadRef}
                                                name="news"
                                                accept="application/pdf"
                                                onChange={e => handleAddDocs(e)}
                                                multiple />
                                            {/* <br /> */}
                                            <Button variant="outline-primary"
                                                    style={{ width: "100%", borderRadius: "10px" }}
                                                    onClick={e => handleAutomaticFormDocFileInputClick(e)}>
                                                Upload files&nbsp;&nbsp;
                                                <FontAwesomeIcon icon={faUpload} />
                                            </Button>
                                        </Form.Group>
                                        {/* Display added pdf documents (if there are any) */}
                                        {(newsDocs !== undefined && newsDocs.length !== 0)
                                            ? <>{docsList}<hr /></>
                                            : null
                                        }
                                        <Form.Group className="mb-3">
                                            <Form.Label><b>Images</b></Form.Label>
                                            <Form.Control 
                                                type="file"
                                                ref={formImgUploadRef}
                                                name="news"
                                                accept="image/*"
                                                onChange={e => handleAddImgs(e)}
                                                multiple />
                                            {/* <br /> */}
                                            <Button variant="outline-primary"
                                                    style={{ width: "100%", borderRadius: "10px" }}
                                                    onClick={e => handleAutomaticFormImgFileInputClick(e)}>
                                                Upload images&nbsp;&nbsp;
                                                <FontAwesomeIcon icon={faUpload} />
                                            </Button>
                                        </Form.Group>
                                        {/* Display added pdf documents (if there are any) */}
                                        {(newsImages !== undefined && newsImages.length !== 0)
                                            ? <>{imgsList}<hr /></>
                                            : null
                                        }
                                        <Form.Group className="mb-3">
                                            <Row>
                                                <Col sm={12}>
                                                    <Form.Label>
                                                        <b>Links and resources</b>
                                                    </Form.Label>
                                                    <Form.Control 
                                                        type="url" 
                                                        name="mediaLink"
                                                        value={mediaLink}
                                                        placeholder="Resource URL or link *"
                                                        // format
                                                        onChange={e => setMediaLink(e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={9}>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="displayMediaLink"
                                                        value={displayMediaLink}
                                                        placeholder="Display text (optional)"
                                                        onChange={e => setDisplayMediaLink(e.target.value)} />
                                                </Col>
                                                <Col sm={3} style={{ padding: '0px', textAlign: 'center' }}>
                                                    <Button 
                                                        variant="outline-primary"
                                                        disabled={mediaLink.length === 0 || !isValidHttpUrl(mediaLink)}
                                                        onClick={e => handleAddLink(e)}>
                                                        {mediaLink.length === 0 || !isValidHttpUrl(mediaLink)
                                                            ? <></>
                                                            : <>Add&nbsp;&nbsp;</>
                                                        }
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                            {/* Display added links (if there are any) */}
                                            {(links !== undefined && links.length !== 0)
                                                ? <><br />{linksList}</>
                                                : null
                                            }
                                        </Form.Group>
                                    </Col>
                                </div>
                            </Container>
                            : <></>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="secondary"
                            style={{ width: '100px' }}
                            onClick={() => handleClose()}>
                            Close
                        </Button>
                        <Button 
                            variant={modal.buttonVariant}
                            style={{ width: '100px' }}
                            type="submit" >
                            {props.action.charAt(0).toUpperCase().concat(props.action.substr(1))}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}

export default memo(NewsModal);
